const locale = {
	// #region Fields
	DIALOG_COMMON_ID: 'ID',
	DIALOG_COMMON_TITLE: 'Nome',
	DIALOG_COMMON_DESCRIPTION: 'Descrizione',
	DIALOG_COMMON_ORDER: 'Ordine',
	DIALOG_COMMON_TITLE_INITIALS: 'Iniziali',
	DIALOG_COMMON_DISABLED: 'Disabilitato',
	DIALOG_COMMON_RECOVERY_HOURS: 'Recupero ore',
	DIALOG_LEAVE_TYPES_ADMIN_ONLY: 'Solo per amministratori',
	DIALOG_LEAVE_TYPES_RECOVERY_HOURS: 'Recupero ore',
	DIALOG_LEAVE_TYPES_MIN_NOTICE_DAYS: 'Preavviso minimo (giorni)',
	DIALOG_LEAVE_TYPES_CALENDAR_SHOW: 'Visualizza nel calendario delle disponibilità',
	DIALOG_LEAVE_TYPES_SHOW_TITLE: 'Mostra informazioni nel calendario delle disponibilità',
	DIALOG_LEAVE_TYPES_SHOW_WEEKEND: "Selezionabile fuori dall'orario di lavoro",
	DIALOG_LEAVE_TYPES_SHOW_REPORT: 'Visualizza nel report delle disponibilità'
	// #endregion
};

export default locale;
